module.exports = __webpack_public_path__ + "img/news-gallery-01.png?7ffa87f5b49eb574035cdb15899a3c8f";